module.exports = __webpack_public_path__ + "img/background.92f6047e.png";